(function($) {
    var _GMM_BUYSELECT_MATCHTRADE_VIEW_MODEL = {
        //接口数据
        hasShowGuideMatch: ko.observable(0),
        goodsType: ko.observable(''),
        dianquan_thumbnail_url: ko.observable(''),
        price: ko.observable('0.000'),//当前均价
        showOldDQEntry: ko.observable(false),//经典版点券入口开关
        selling_list: ko.observableArray([]),//卖出列表
        wantbuy_list: ko.observableArray([]),//买入列表
        init:function(){
            var self = this;
            self.GetTransactionIndexData();
            self.getConfig();
            self.getDQEntrySwitch();
        },
        getConfig:function(){
            var self = this;
            var url="/api/accountapi/config";
            var params={
                    method:"GetGameInfo",
                    params:JSON.stringify({
                        "game_id":791000218
                    })
                };
            $.ajaxBridgeCache(url,
                function(response){
                    if (response.return_code === 0){
                        var data = response.data;
                        self.dianquan_thumbnail_url(data.ext_info.dianquan_thumbnail_url);

                    }
                },
                params,"GET",false,0,
                function(response){
                    return $.BizReturnCodeCheck(response);
                },
                null
            );
        },
        //数字转中文数字
        NumberToChinese:function(num){
            function SectionToChinese(section){
              var strIns = '', chnStr = '';
              var unitPos = 0;
              var zero = true;
              while(section > 0){
                var v = section % 10;
                if(v === 0){
                  if(!zero){
                    zero = true;
                    chnStr = chnNumChar[v] + chnStr;
                  }
                }else{
                  zero = false;
                  if (unitPos == 1 && v == 1){//位数为十且十位数是1，即一十显示为十
                    strIns = '';                    
                  } else {
                    strIns = chnNumChar[v];
                  }                 

                  strIns += chnUnitChar[unitPos];
                  chnStr = strIns + chnStr;
                }
                unitPos++;
                section = Math.floor(section / 10);
              }
              return chnStr;
            }
            var chnNumChar = ["零","一","二","三","四","五","六","七","八","九"];
            var chnUnitSection = ["","万","亿","万亿","亿亿"];
            var chnUnitChar = ["","十","百","千"];
            var unitPos = 0;
            var strIns = '',
                chnStr = '';
            var needZero = false;

            if (num === 0) {
                return chnNumChar[0];
            }

            while (num > 0) {
                var section = num % 10000;
                if (needZero) {
                    chnStr = chnNumChar[0] + chnStr;
                }
                strIns = SectionToChinese(section);
                strIns += (section !== 0) ? chnUnitSection[unitPos] : chnUnitSection[0];
                chnStr = strIns + chnStr;
                needZero = (section < 1000) && (section > 0);
                num = Math.floor(num / 10000);
                unitPos++;
            }
            return chnStr;

        },
        getSellTitle:function(index){
            switch(index){
                case 0:
                    return '卖出五';
                case 1:
                    return '卖出四';
                case 2:
                    return '卖出三';
                case 3:
                    return '卖出二';
                case 4:
                    return '卖出一';
            }
        },
        sellTips:function(){
            $.toast('暂不支持，请在电脑上操作。');
        },
        GetTransactionIndexData:function(){
            var self = this;
            var url="/api/dianquanapi/order";
            var params={
                    method:"GetTransactionIndexData",
                    params:JSON.stringify({
                        "req_from":0,
                        "currency_id":3
                    })
                };
            $.ajaxBridgeCache(url,
                function(response){
                    if (response.return_code === 0){
                        var data = response.data;
                        self.price(data.price);
                        if (data.selling_list){
                            var selllist = data.selling_list.reverse();
                            selllist.forEach(function(item,index){
                                item.title =  '卖出' + self.NumberToChinese(index + 1);
                            })
                            self.selling_list(selllist.reverse());
                        }
                        if (data.wantbuy_list){
                            var buylist = data.wantbuy_list;
                            buylist.forEach(function(item,index){
                                item.title =  '买入' + self.NumberToChinese(index + 1);
                            })
                            self.wantbuy_list(buylist);
                        }
                        
                    }
                },
                params,"GET",false,0,
                function(response){
                    return $.BizReturnCodeCheck(response);
                },
                null
            );
        },
        //经典版点券入口开关配置
        getDQEntrySwitch:function(){
            var self = this;
            var url='/gmminf/accountapi/config/';
            var params={
                    method:'GetLatestVersion',
                    params:JSON.stringify({
                        type: 'dianquan_cfg',
                    })
                };
                $.ajaxBridgeCache(url,
                    function(response){
                        if (response.return_code === 0){
                            var data = response.data.data;
                            if(data.classic_version_switch){
                                self.showOldDQEntry(true);
                            }
                        }
                    },
                    params,"GET",false,0,
                    function(response){
                        return $.BizReturnCodeCheck(response);
                    },
                    null
                );
        },
        goBuyMatch:function(){
            //$.router.load('/m/buyconfirm/matchtrade_buy.html?game_id=791000218');
            $.router.load('/h5/buyconfirm/matchtrade_buy/index.html?game_id=791000218');
        }
    };

    //页面入口函数
    $.PageReadyEntry_Matchtrade = function() {
        console.log("PageReadyEntry_Matchtrade");
        $.init();
        var expires_date = new Date('2066/01/01'); //deviceid在cookie过期时间50年
        var hasShowGuideMatch = $.getCookie("gmmh5_hasShowGuideMatch");
        if (hasShowGuideMatch == 0){
            _GMM_BUYSELECT_MATCHTRADE_VIEW_MODEL.hasShowGuideMatch(1);
        } else {
            _GMM_BUYSELECT_MATCHTRADE_VIEW_MODEL.hasShowGuideMatch(0);
        }
        var koBindDom = $(".page-matchtrade")[0];
        var koBindFlag = $(koBindDom).attr("gmm-bind-flag");
        if (koBindFlag != "1") {
            ko.applyBindings(_GMM_BUYSELECT_MATCHTRADE_VIEW_MODEL, koBindDom);
            $(koBindDom).attr("gmm-bind-flag", "1");
            $(document).on('touchend', '#pop-matchtrade-guide', function(event) {
                $(this).hide();
                $.setCookie("gmmh5_hasShowGuideMatch", "1",expires_date);
            });
            $(document).on('click', '#pop-matchtrade-guide', function(event) {
                $(this).hide();
                $.setCookie("gmmh5_hasShowGuideMatch", "1",expires_date);
            });
            _GMM_BUYSELECT_MATCHTRADE_VIEW_MODEL.init();

            $(document).on('click', '.dq-back', function(event) {
                console.log($.urlParam("fromUrl"))
                if ($.urlParam("fromUrl")) {
                    $.router.load(decodeURIComponent($.urlParam("fromUrl")))
                } else {
                    // $.router.load('/m/index/index.html')
                    $.router.load('/h5/index/homeios/index.html')
                }
            });
        }
        
    };
})(Zepto)
